import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const register = async (userData) => {
  try {
    return await customFetch(API_ENDPOINTS.NEW_MEMBER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userData)
    });
  } catch (error) {
    console.error('ユーザー登録エラー:', error);
    throw error;
  }
};

export const userService = {
  register
};
